import { Card, PageContainer } from '@aimsos/ui';

/** Centered card frame shared by every recipient-side invitation screen. */
function InvitationShell({ children }) {
  return (
    <PageContainer>
      <div className="mx-auto flex min-h-[60vh] max-w-lg items-center justify-center">
        <Card className="w-full">
          <Card.Body className="flex flex-col gap-4 p-8">{children}</Card.Body>
        </Card>
      </div>
    </PageContainer>
  );
}

export default InvitationShell;
